import { b64DecodeUnicode } from '@shared/utils/common';
import { specialCharsRegex } from '@shared/utils/masks';
import { HttpResponse } from '@angular/common/http';

export function downloadFile({
  data,
  type,
  name = '',
}: {
  data: string | Blob;
  type?: string;
  name: string;
}) {
  const blob = new Blob([data], { type });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  if (name) {
    link.download = name;
  }
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 10000);
}

export function getSanitizedNameFromContentDisposition(
  contentDisposition: Nullable<string>,
) {
  const base64string = getFilenameFromContentDisposition(contentDisposition);
  return b64DecodeUnicode(decodeURIComponent(base64string)).replace(
    specialCharsRegex,
    '',
  );
}
export function getFilenameFromContentDisposition(
  contentDisposition: Nullable<string>,
) {
  const disposition = contentDisposition || '';
  if (disposition) {
    const filename = disposition.split(';')[1];
    const value = filename.includes("filename*=UTF-8''")
      ? filename.replace("filename*=UTF-8''", '').trim()
      : filename.replace('filename=', '').replaceAll('"', '').trim();
    return decodeURI(value);
  }
  return '';
}

export function openFileInNewTab(res: HttpResponse<Blob>, window: Window) {
  const blob = res.body;
  if (!blob) {
    return;
  }
  const name = getFilenameFromContentDisposition(
    res.headers.get('content-disposition'),
  );

  const file = new File([blob], name, { type: blob.type });
  const newTab = window.open('', '_blank'); // Открываем пустую вкладку
  const fileURL = URL.createObjectURL(file);
  if (newTab) {
    newTab.document.write(`
    <html>
      <head>
        <title>${name}</title>
        <style>
          body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
          iframe { width: 100%; height: 100%; border: none; }
        </style>
      </head>
      <body>
        <iframe src="${fileURL}"></iframe>
      </body>
    </html>
  `);
    newTab.document.close();

    newTab.addEventListener('beforeunload', () => {
      URL.revokeObjectURL(fileURL);
    });
  }
}
